import { format, isValid } from 'date-fns';

/**
 * Format date for input display (DD/MM/YYYY)
 */
export function formatForInput(date: Date | undefined): string {
  if (!date || !isValid(date)) return '';
  return format(date, 'dd/MM/yyyy');
}

/**
 * Auto-format input - only when typing pure digits at the end
 */
export function autoFormatDateInput(input: string, prevInput: string): string {
  if (input.includes('//')) {
    return input.replace(/\/+/g, '/');
  }

  if (input.slice(-1) === '/' && prevInput.slice(-1) === '/') {
    return prevInput;
  }

  if (input.length < prevInput.length) return input;

  const lastChar = input.slice(-1);
  const isAddingDigitAtEnd = /\d/.test(lastChar) && input.slice(0, -1) === prevInput;

  if (!isAddingDigitAtEnd) return input;

  const digits = input.replace(/\D/g, '');

  if (digits.length === 2 && !input.includes('/')) {
    return digits + '/';
  }
  if (digits.length === 4 && input.split('/').length < 3) {
    return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/`;
  }

  return input;
}

/**
 * Parse flexible date input to Date
 * Supports: DDMMYYYY, DD/MM/YYYY, D/M/YYYY, DD/M/YYYY, D/MM/YYYY, etc.
 */
export function parseInputDate(input: string): Date | undefined {
  if (!input) return undefined;

  const digits = input.replace(/\D/g, '');

  if (digits.length === 8) {
    const day = parseInt(digits.slice(0, 2), 10);
    const month = parseInt(digits.slice(2, 4), 10);
    const year = parseInt(digits.slice(4, 8), 10);

    if (day >= 1 && day <= 31 && month >= 1 && month <= 12 && year >= 1900 && year <= 2100) {
      const date = new Date(year, month - 1, day);
      if (isValid(date) && date.getDate() === day) return date;
    }
  }

  const parts = input.split('/');
  if (parts.length === 3) {
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const year = parseInt(parts[2], 10);

    if (day >= 1 && day <= 31 && month >= 1 && month <= 12 && year >= 1900 && year <= 2100) {
      const date = new Date(year, month - 1, day);
      if (isValid(date) && date.getDate() === day) return date;
    }
  }

  return undefined;
}
